import React from 'react';
import s from './GalleryGrid.module.scss';
import GalleryHeaderContainer from '../GalleryHeader/GalleryHeaderContainer';
const GalleryGrid = _ref => {
  let {
    content,
    header,
    listGridClassOverride,
    listClassName
  } = _ref;
  const listGridClass = listGridClassOverride ? listGridClassOverride : s.content;
  return /*#__PURE__*/React.createElement("div", {
    className: s.gridContainer
  }, /*#__PURE__*/React.createElement(GalleryHeaderContainer, {
    className: s.header
  }, header), /*#__PURE__*/React.createElement("ul", {
    className: `${listGridClass} ${listClassName}`
  }, content));
};
export default GalleryGrid;
//# sourceMappingURL=GalleryGrid.js.map